import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetShowInventory, SetCookie } from "@insite/client-framework/Store/Context/Handlers/SetShowInventory"; 

interface Parameter {
    showInventory: boolean;
}

type HandlerType = Handler<Parameter>;

export const SetCookieExtension: HandlerType = props => {};

export const DispatchSetShowInventoryExtension: HandlerType = props => {};

replaceInChain(chain, SetCookie, SetCookieExtension);

replaceInChain(chain, DispatchSetShowInventory, DispatchSetShowInventoryExtension);